export const uk = {
    manager: 'Менеджер',
    'support-phone': 'Телефоны поддержки'
};
